import { Component } from '@theme/component';

/**
 * "Designers" carousel host. Layout/motion is CSS-driven; this component
 * only wires the prev/next arrow buttons to scroll the track one card
 * width at a time using native smooth scrolling.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} track
 *
 * @extends Component<Refs>
 */
class DesignersCarousel extends Component {
  requiredRefs = ['track'];

  /** @type {(() => void) | null} */
  #onPrev = null;
  /** @type {(() => void) | null} */
  #onNext = null;

  connectedCallback() {
    super.connectedCallback();

    const prev = this.querySelector('[data-dsg-prev]');
    const next = this.querySelector('[data-dsg-next]');

    if (prev) {
      this.#onPrev = () => this.#scrollByCards(-1);
      prev.addEventListener('click', this.#onPrev);
    }
    if (next) {
      this.#onNext = () => this.#scrollByCards(1);
      next.addEventListener('click', this.#onNext);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const prev = this.querySelector('[data-dsg-prev]');
    const next = this.querySelector('[data-dsg-next]');
    if (prev && this.#onPrev) prev.removeEventListener('click', this.#onPrev);
    if (next && this.#onNext) next.removeEventListener('click', this.#onNext);
  }

  #scrollByCards(direction) {
    const track = this.refs.track;
    if (!track) return;
    const item = track.querySelector('.dsg__item');
    const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    const step = (item ? item.getBoundingClientRect().width : track.clientWidth / 2) + gap;
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }
}

if (!customElements.get('designers-carousel')) {
  customElements.define('designers-carousel', DesignersCarousel);
}
